import Appear from "./appear";
import BlockQuote from "./block-quote";
import Cite from "./cite";
import Code from "./code";
import Deck from "./deck";
import Fill from "./fill";
import Fit from "./fit";
import Heading from "./heading";
import Image from "./image";
import Layout from "./layout";
import Link from "./link";
import ListItem from "./list-item";
import List from "./list";
import Quote from "./quote";
import S from "./s";
import Slide from "./slide";
import Text from "./text";

export {
  Appear,
  BlockQuote,
  Cite,
  Code,
  Deck,
  Fill,
  Fit,
  Heading,
  Image,
  Layout,
  Link,
  ListItem,
  List,
  Quote,
  S,
  Slide,
  Text
};



// WEBPACK FOOTER //
// ./~/@jimpick/spectacle/src/spectacle.jsx